import NavigableValidation from "./navigableValidation";
import ListView from "../listViews/listView";
import IDefaultSortOptions from "~/interfaces/defaultSortOptions";
import ContentElementPropertiesValidator from "../navigableValidators/contentElementPropertiesValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import {IErrorNavOpts} from "~/models/validationError";
import {ErrorType} from "~/enums/ErrorType";
import { StringHelper } from "~/helpers/stringHelper";
import SlugValidator from "../navigableValidators/slugValidator";
import LengthValidator from "../navigableValidators/lengthValidator";

export default class ListViewBuilderValidation extends NavigableValidation<ListView> {
  validators = [
    new ContentElementPropertiesValidator({
      validatorKey: 'content_elements',
      section: ValidationModalSection.Layout
    }),
    new NavigableValidator({
      validatorKey: 'default_sort_options',
      section: ValidationModalSection.Settings,
      validator: (value: IDefaultSortOptions[], model: ListView) => {
        return value.every((sortOpt) => {
          return !!model.object_model.objectModelPropertyHandler.find(sortOpt.id);
        });
      },
      type: ErrorType.nonexistentProperties,
      message: 'Some properties no longer exist',
    }),
    new NavigableValidator({
      validatorKey: 'short_description',
      section: ValidationModalSection.Settings,
      validator: (value: string, model: ListView) => {
        // short_description starts as null
        if (!value) return true
        return StringHelper.stripHtml(value).length < 500
      },
      type: ErrorType.invalidValue,
    }),
    new SlugValidator({
      validatorKey: "seo_slug",
      section: ValidationModalSection.Settings,
      conditional: (listView: ListView) => listView.show_seo,
    }),
    new LengthValidator(0, 50, {
      validatorKey: 'seo_slug',
      section: ValidationModalSection.Settings,
      conditional: (listView: ListView) => listView.show_seo,
    }),
    new FieldPresenceValidator({
      validatorKey: 'seo_title',
      section: ValidationModalSection.Settings,
      conditional: (listView: ListView) => listView.show_seo,
    }),
    new LengthValidator(0, 160, {
      validatorKey: 'seo_meta_description',
      section: ValidationModalSection.Settings,
      conditional: (listView: ListView) => listView.show_seo,
    }),
  ];

  errorNavOpts(validator: NavigableValidator<ListView>, validatorKey: string, value?, ...rest): IErrorNavOpts {
    const opts = super.errorNavOpts(validator, validatorKey, value, ...rest);
    if (validator.section === ValidationModalSection.Settings) {
      opts.containerElementSelector = ".scroll-area.dual-nav-builder"
    }
    return opts
  }
}
